import axios from './_inveAxios'

export const obtenerAsSelect2Presupuesto = ({ busqueda }) =>
  axios.get('/productos', { params: { busqueda, tipoConsulta: 'select2-presupuesto' } })

export const getProducto = _id => axios.get(`/productos/${_id}`)

export const getProducto_Ventas = (_id) =>
  axios.get(`/productos/presentaciones/${_id}`, {
    params: {
      tipoConsulta: 'presupuestos'
    }
  })

